import { createAsyncThunk } from '@reduxjs/toolkit';
import { classToPlain } from 'class-transformer';
import { FORM_ERROR } from 'final-form';

import { AppError } from '@vk-hr-tek/core/error';
import {
  showCustomNotification,
  showNotification,
} from '@vk-hr-tek/core/notifications';

import { SettingsService } from '@app/gen/settings';

import { ThunkExtra, ThunkValuesAndActions } from '../../../../app/store';
import { UploadLogoDto } from '../../../dto';
import { SettingsWithRootState } from '../../settings.state';

export const uploadLogo = createAsyncThunk<
  void,
  ThunkValuesAndActions<UploadLogoDto>,
  ThunkExtra<SettingsWithRootState>
>(
  'settings/uploadLogo',
  async (
    { values, actions },
    { rejectWithValue, dispatch, extra: { inject } },
  ) => {
    try {
      await inject(SettingsService).updateCompanyLogo({
        params: { company_id: values.companyId },
        body: {
          main: values.main,
          ...(values.compact ? { compact: values.compact } : {}),
        },
      });
      actions.resolve(null);

      dispatch(showNotification(`Логотип успешно изменен!`));
    } catch (err) {
      actions.reject({ [FORM_ERROR]: err });

      dispatch(
        showCustomNotification([
          {
            type: 'error',
            title: 'Не удалось загрузить логотип',
            message: 'Попробуйте еще раз позже',
          },
        ]),
      );

      return rejectWithValue(classToPlain(err) as AppError);
    }
  },
);
